import script from "./ProfileButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileButton.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileButton.vue?vue&type=style&index=0&id=7e2e8a2a&scoped=true&lang=scss"

import exportComponent from "/app/ViewpointPBIEmbedded/ViewpointPBIEmbedded.BFF/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e2e8a2a"]])

export default __exports__